import * as React from "react";
import { Chip } from "@mui/material";
import CustomCheckbox from "./CustomCheckbox";
import CloseIcon from "@mui/icons-material/Close";
import Autocomplete from "@mui/material/Autocomplete";
import "../../../assets/styles/containers/_commentFilter.scss";
import { Paper, Box, TextField, Typography } from "@mui/material";

function FilterTags(props) {
  const { filterTagList, filterType, GetCommentList, selectedFilterTagID: propSelectedIds, setSelectedFilterTagID, setState, state } = props;
  const selectedFilterTagID = propSelectedIds || state?.selectedFilterTagID || [];

  function CustomPaper({ children }) {
    return (
      <Paper
        sx={{
          "& .MuiAutocomplete-listbox": { "& .MuiAutocomplete-option[aria-selected='true']": { bgcolor: "white", "&.Mui-focused": { bgcolor: "white", }, }, },
          "& .MuiAutocomplete-listbox .MuiAutocomplete-option.Mui-focused": { bgcolor: "white" },
          border: "1px solid #D5D5D5",
          borderRadius: "4px",
        }} >{children}</Paper>
    );
  }

  function getContrastTextColor(hexColor) {
    hexColor = hexColor.replace('#', '');
    if (hexColor.length === 3) {
      hexColor = hexColor.split('').map(c => c + c).join('');
    }
    const r = parseInt(hexColor.substring(0, 2), 16) / 255;
    const g = parseInt(hexColor.substring(2, 4), 16) / 255;
    const b = parseInt(hexColor.substring(4, 6), 16) / 255;
    const linear = [r, g, b].map(c =>
      c <= 0.03928
        ? c / 12.92
        : Math.pow((c + 0.055) / 1.055, 2.4)
    );
    const luminance =
      0.2126 * linear[0] +
      0.7152 * linear[1] +
      0.0722 * linear[2];
    return luminance > 0.5 ? "#000000" : "#FFFFFF";
  }

  return (
    <Autocomplete
      multiple
      size="small"
      limitTags={2}
      options={filterTagList || []}
      id="filter-by-tags"
      PaperComponent={CustomPaper}
      value={filterTagList?.filter((tag) => (selectedFilterTagID)?.includes(tag?.id)) || []}
      onChange={(e, value) => {
        GetCommentList?.({ filterByTagId: value?.map((item) => item?.id)?.filter((id) => id !== undefined), filterByType: filterType }, "filter");
        setState?.((prevState) => ({
          ...prevState,
          selectedFilterTagID: value?.map((item) => item?.id)?.filter((id) => id !== undefined),
          page: 0,
        }));
        setSelectedFilterTagID?.(value?.map((item) => item?.id)?.filter((id) => id !== undefined));
      }}
      getOptionLabel={(option) => option.name || option.title}
      sx={{ marginLeft: "8px", fontFamily: "Open sans" }}
      renderTags={(value, getTagProps) => {
        const visible = value?.slice(0, 1);
        const hiddenCount = value?.length - visible?.length;
        return (
          <>
            {visible?.map((option, index) => (
              <Chip
                key={option?.id ?? `${option}-${index}`}
                size="small"
                style={{
                  borderRadius: "35px",
                  border: "1px solid #CED2DA",
                  backgroundColor: option?.color,
                  color: getContrastTextColor(option?.color),
                }}
                deleteIcon={
                  <div style={{
                    backgroundColor: "#black",
                    borderRadius: "50%",
                    height: "16px",
                    width: "16px",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                  >
                    <CloseIcon style={{ color: getContrastTextColor(option?.color), height: "14px", width: "14px" }} />
                  </div>
                }
                label={<span>{option.name || option.title}</span>}
                {...getTagProps({ index })}
              />
            ))}
            {hiddenCount > 0 && (
              <Typography sx={{ ml: 0.5 }}>{`+${hiddenCount}`}</Typography>
            )}
          </>
        );
      }}
      renderOption={(props, option, { selected }) => {
        return (
          <li {...props} key={option?.id}>
            <Box display={"flex"} gap={"8px"} alignItems="center">
              <CustomCheckbox checked={selected} />
              <Box
                sx={{
                  width: "12px",
                  height: "12px",
                  backgroundColor: option?.color,
                  borderRadius: "50%",
                  flexShrink: 0,
                }}
              />
              <Typography
                color={"text.primary"}
                style={{
                  fontSize: "16px",
                  lineHeight: "24px",
                  wordBreak: "break-word",
                }}
              >
                {option.name || option.title}
              </Typography>
            </Box>
          </li>
        );
      }}
      renderInput={(params) => <TextField sx={{ backgroundColor: "white" }} size="small" {...params} placeholder={((params?.inputProps?.value?.length === 0 && state?.selectedFilterTagID?.length === 0) || selectedFilterTagID?.length === 0) ? "Filter by tags" : ""} />}
    />
  );
}

export default FilterTags;